export const IconHourGlass = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      {...props}
    >
      <path d="M11.778 11q1.605 0 2.746-1.175Q15.667 8.65 15.667 7V4H7.889v3q0 1.65 1.142 2.825Q10.174 11 11.778 11M4 22v-2h1.944v-3q0-1.525.693-2.863A5.5 5.5 0 0 1 8.57 12a5.5 5.5 0 0 1-1.932-2.137A6.14 6.14 0 0 1 5.944 7V4H4V2h15.556v2H17.61v3q0 1.524-.693 2.863A5.5 5.5 0 0 1 14.986 12a5.5 5.5 0 0 1 1.932 2.137q.693 1.338.693 2.863v3h1.945v2z" />
    </svg>
  );
};
